import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import matchReducer from "./matchFilterSlice";
import profileReducer from "./profileFilterSlice";
import successStorySlice from "./successStorySlice";
import interestReducer from "./interestSlice";
import shortListReducer from "./shortListSlice";
import paymentUsers  from "./paymentUsersSlice";

//combine all reducers
const appReducer  = combineReducers({
  auth: authReducer,
  matches: matchReducer,
  profile: profileReducer,
  successStories: successStorySlice,
  interests: interestReducer,
  shortList: shortListReducer,
  paymentUsers: paymentUsers
});

//create root reducer(reset logic)
const rootReduction = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReduction
});

export default store;